import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../global-components/src';

interface BrownStampRouteProps {
    children: React.ReactNode;
}

const BrownStampRoute: React.FC<BrownStampRouteProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!user?.stamps?.includes('brown')) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default BrownStampRoute;
